import { jsx, jsxs } from "react/jsx-runtime";
import { Flex, ThemeProvider } from "pcln-design-system";
import react, { useEffect } from "react";
import styled_components from "styled-components";
import { getMapPinOnClickHandler } from "./getMapPinOnClickHandler.js";
import { HotelPricePin } from "./HotelPricePin.js";
import { SinglePinIcon } from "./SinglePinIcon.js";
import { SinglePinLabel } from "./SinglePinLabel.js";
const StyledFlex = /*#__PURE__*/ styled_components(Flex).withConfig({
    displayName: "MapPinElement__StyledFlex"
})([
    ":hover{cursor:pointer;}"
]);
function MapPinElement(props) {
    const domRef = react.useRef(null);
    domRef.current = props.markerDOM;
    useEffect(()=>{
        if (domRef.current) {
            const clickHandler = (event)=>{
                const handler = getMapPinOnClickHandler(props);
                handler(event);
            };
            domRef.current.addListener('click', clickHandler);
        }
    }, [
        props.markerDOM
    ]);
    const hasPrice = Boolean(props?.hotel?.ratesSummary?.grandTotal) || Boolean(props?.hotel?.ratesSummary?.minPrice);
    return /*#__PURE__*/ jsx(ThemeProvider, {
        children: /*#__PURE__*/ jsxs(StyledFlex, {
            alignItems: "center",
            style: {
                transform: 'translateX(50%)'
            },
            children: [
                hasPrice ? /*#__PURE__*/ jsx(HotelPricePin, {
                    ...props
                }) : /*#__PURE__*/ jsx(SinglePinIcon, {
                    type: props.type
                }),
                /*#__PURE__*/ jsx(SinglePinLabel, {
                    ...props
                })
            ]
        })
    });
}
export { MapPinElement };
